import React, { useState, useContext } from 'react'
import { QlikUIContext } from '../QlikUIContext'
import { useReportsQlikApi } from '../api/reportsQlik/reportsQlik.api'
import { Loader } from './Loader'
import { Button } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

export const QlikSyncButton = ({ qlikAsync, onEndSynchronization }) => {
  const [t] = useTranslation(['qlik'])

  const [isSync, setIsSync] = useState(false)
  const [logSync, setLogSync] = useState({ text: '', reset: true, show: true })

  const context = useContext(QlikUIContext)

  const apiReportsQlik = useReportsQlikApi()

  const qlikSynchronization = async () => {
    //Mostrar modal durante todo el proceso
    setIsSync(true)

    const qlikConfig = {
      host: context.qlikEnvironmentUrl,
      prefix: context.qlikPrefix,
      port: context.qlikPort,
      secure: context.qlikSecure,
      isSecure: context.qlikSecure
    }

    const qlikWidgets = []
    const newAmbits = []

    const ambits = await apiReportsQlik.GetAllAmbits()

    qlikAsync().then((qlik) => {
      qlik.getGlobal(qlikConfig).getAppList(function (apps) {
        apps.map((app) => {
          let localAmbit = ambits.find((p) => p.Id === app.qDocId)
          if (localAmbit != undefined) {
            const appObj = qlik.openApp(app.qDocId, qlikConfig)

            let stream = { Id: null, Name: null }
            if (app.qMeta.stream !== null) {
              stream = { Id: app.qMeta.stream.id, Name: app.qMeta.stream.name }
            }

            let description = ''
            if (app.qMeta.description != null) {
              description = app.qMeta.description
            }

            let thumbnailUrl = ''
            if (app.qThumbnail != null && app.qThumbnail.qUrl) {
              thumbnailUrl =
                'https://' +
                context.qlikEnvironmentUrl +
                '/qlik' +
                app.qThumbnail.qUrl
            }

            let ambit = {
              Id: app.qDocId,
              Name: app.qDocName,
              Stream: stream,
              ThumbnailUrl: thumbnailUrl,
              ReportType: localAmbit.ReportType,
              Description: description,
              Dimensions: []
            }

            appObj.getList('DimensionList', function (reply) {
              reply.qDimensionList.qItems.map((item) => {
                let dimension = {
                  Id: item.qInfo.qId,
                  Title: item.qMeta.title,
                  Description: item.qMeta.description
                }
                ambit.Dimensions.push(dimension)
              })
              newAmbits.push(ambit)

              logSynchronization(
                newAmbits.length + t('qlik:qlikSyncButton.downloadedAmbits'),
                true
              )
              logSynchronization(
                qlikWidgets.length + t('qlik:qlikSyncButton.downloadedWidgets'),
                false
              )
            })
          }
        })

        setTimeout(async () => {
          logSynchronization(
            t('qlik:qlikSyncButton.savingAmbits', {
              length: qlikWidgets.length
            }),
            false
          )
          await apiReportsQlik.SaveAmbits(newAmbits)
        }, 120000)
      })
    })

    //Sincronizar qlikWidgets

    qlikAsync().then((qlik) => {
      ambits.map((ambit) => {
        const appObj = qlik.openApp(ambit.Id, qlikConfig)

        appObj.getList('sheet', function (reply) {
          reply.qAppObjectList.qItems.map((item) => {
            item.qData.cells.map((obj) => {
              let qlikWidget = null

              appObj.getObjectProperties(obj.name).then(function (model) {
                var title = ''
                if (model != null && model.properties != null) {
                  title = model.properties.title
                }

                qlikWidget = {
                  Name: obj.name,
                  Type: obj.type,
                  AmbitId: ambit.Id,
                  Title: title,
                  Width: obj.colspan,
                  Height: obj.rowspan
                }
                qlikWidgets.push(qlikWidget)

                logSynchronization(
                  newAmbits.length + t('qlik:qlikSyncButton.downloadedAmbits'),
                  true
                )
                logSynchronization(
                  qlikWidgets.length +
                    t('qlik:qlikSyncButton.downloadedWidgets'),
                  false
                )
              })
            })
          })
        })
      })
    })

    setTimeout(async () => {
      logSynchronization(
        t('qlik:qlikSyncButton.savingWidgets', {
          length: qlikWidgets.length
        }),
        false
      )
      await apiReportsQlik.SaveQlikWidgets(qlikWidgets)
    }, 120000)

    setTimeout(async () => {
      setIsSync(false)
      onEndSynchronization()
    }, 150000)
  }

  const logSynchronization = (text, reset) => {
    setLogSync({ text: text, reset: reset, show: true })
  }

  return (
    <React.Fragment>
      <Button
        onClick={qlikSynchronization}
        title={t('qlik:qlikSyncButton.label')}
        color='primary'
        variant='contained'
      >
        {t('qlik:qlikSyncButton.syncButton')}
      </Button>

      {isSync && (
        <Loader
          title={t('qlik:qlikSyncButton.label')}
          text={t('qlik:qlikSyncButton.text')}
          log={logSync}
        />
      )}
    </React.Fragment>
  )
}
